import { Image } from 'lucide-static';
import { Icon } from './Icon';

export function Avatar({ src, alt }: { src?: string | undefined; alt?: string }) {
	const view: HTMLElement = (
		<div
			data-loading
			class="grid size-10 place-items-center overflow-hidden rounded-md border border-gray-300 bg-gray-200 data-[loading]:animate-pulse"
		>
			{src ? (
				<img class="size-full object-cover" src={src} alt={alt ?? 'avatar'} />
			) : (
				<Icon icon={Image} class="size-6 text-gray-400" />
			)}
		</div>
	);
	const img = view.querySelector('img') as HTMLImageElement;
	if (img) {
		img.onerror = function () {
			view.removeAttribute('data-loading');
			view.setAttribute('data-fallback', '');
			img.remove();
		};
		img.onload = function () {
			view.removeAttribute('data-loading');
		};
	} else {
		view.removeAttribute('data-loading');
		view.setAttribute('data-fallback', '');
	}
	return view;
}
